const BASE_STYLE: React.CSSProperties = {
  height: '1.25rem',
  borderRadius: '0.25rem',
  fontFamily: 'Inter, sans-serif',
  fontWeight: 500,
  fontSize: '0.75rem',
  lineHeight: '1.25rem',
  letterSpacing: '0.06px',
  verticalAlign: 'middle',
  border: 'none',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '0 0.375rem',
};

const STATUS_STYLES: Record<string, React.CSSProperties> = {
  SCANNED: { ...BASE_STYLE, width: '4.375rem', background: '#DEF0FF', color: '#003FD2' },
  SIGNEDOFF: { ...BASE_STYLE, width: '5rem', background: '#DAF3EE', color: '#00795C' },
  DRAFTED: { ...BASE_STYLE, width: '4.0625rem', background: '#FEECD5', color: '#AC5000' },
};

export const getStatusStyle = (status: string | undefined): React.CSSProperties =>
  STATUS_STYLES[status || ''] || { ...BASE_STYLE, width: 'auto', background: '#f0f0f0', color: '#666666' };
